import { action } from 'sky-engine/api/index'

import { TERMINAL_MNG } from '@/api/apiModules'
/**
 * 获取外设信息
 * @param {*} data
 * @returns
 */
export function getTerminalList(data) {
  return action(TERMINAL_MNG, 'list', data)
}
